<e-card2 class="shortcut-bar-card" padding="2">
  @if (mobile()) {
  <!-- Mobiele toolbar (docs/MOBIEL.md §9 besluit 2): de essentiële acties met
       volwaardige tap-targets; alles daarbuiten zit achter het ⋮-menu. -->
  <div class="shortcut-bar shortcut-bar--mobile" [attr.aria-label]="t('humanDesign.chart.shortcutBar.ariaLabel')">
    <button eBtn size="sm" squared type="button"
      [color]="sideMode() === 'full' ? 'highlight' : 'elegant'"
      [textColor]="sideMode() === 'full' ? 'primary-75' : undefined"
      [tooltip]="t('humanDesign.chart.shortcutBar.mobileSideCycleTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.mobileSideCycleTooltip')"
      [disabled]="tripleViewActive()"
      data-test-id="mobile-side-cycle"
      (click)="onMobileSideCycle()"
    ><span class="mobile-side-label">{{ mobileSideLabel() }}</span></button>

    <button eBtn size="sm" squared type="button" icon="compass"
      [color]="mobileMandalaActive() ? 'primary-75' : 'highlight'"
      [iconColor]="mobileMandalaActive() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.mobileMandalaTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.mobileMandalaTooltip')"
      [attr.aria-pressed]="mobileMandalaActive()"
      data-test-id="mobile-mandala-toggle"
      (click)="onMobileMandalaToggle()"
    ></button>

    @if (mobileMandalaActive()) {
      <button eBtn size="sm" squared type="button" icon="chart-pie"
        [color]="anyRingVisible() ? 'primary-75' : 'highlight'"
        [iconColor]="anyRingVisible() ? undefined : 'primary-75'"
        [tooltip]="t('humanDesign.chart.shortcutBar.mobileRingCycleTooltip')"
        [attr.aria-label]="t('humanDesign.chart.shortcutBar.mobileRingCycleTooltip')"
        data-test-id="mobile-ring-cycle"
        (click)="ringCycleRequested.emit()"
      ></button>
    }

    <button eBtn size="sm" squared type="button" icon="clock-rotate-left"
      [color]="justNowTransitActive() ? 'primary-75' : 'highlight'"
      [iconColor]="justNowTransitActive() ? undefined : 'primary-75'"
      [tooltip]="justNowTransitTooltip()"
      [attr.aria-pressed]="justNowTransitActive()"
      [disabled]="!justNowTransitAvailable()"
      data-test-id="mobile-just-now-transit"
      (click)="justNowTransitToggled.emit()"
    ></button>

    <button eBtn size="sm" squared type="button" icon="lock-keyhole"
      [color]="locksKeysActive() ? 'primary-75' : 'highlight'"
      [iconColor]="locksKeysActive() ? undefined : 'primary-75'"
      [tooltip]="t(locksKeysAvailable() ? 'humanDesign.chart.shortcutBar.locksKeysTooltip' : 'humanDesign.chart.shortcutBar.locksKeysUnavailableTooltip')"
      [attr.aria-pressed]="locksKeysActive()"
      [disabled]="!locksKeysAvailable()"
      data-test-id="mobile-locks-keys"
      (click)="locksKeysToggled.emit()"
    ></button>

    <!-- Transits (docs/MOBIEL.md §9): zelfde volgorde als desktop (na Locks & Keys);
         de maan-transit zit op phone achter het ⋮-menu. -->
    <button eBtn size="sm" squared type="button" icon="planet-ringed"
      [color]="transitsActive() ? 'primary-75' : 'highlight'"
      [iconColor]="transitsActive() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.transits.shortcutBar.transitsTooltip')"
      [attr.aria-pressed]="transitsActive()"
      data-test-id="mobile-transits"
      (click)="transitsToggled.emit()"
    ></button>

    <button eBtn size="sm" squared type="button" color="elegant" icon="table-list"
      [tooltip]="t('humanDesign.chart.shortcutBar.chartManagerTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.chartManagerAria')"
      data-test-id="mobile-chart-manager"
      (click)="chartManagerRequested.emit()"
    ></button>

    <button eBtn size="sm" squared type="button" color="highlight" icon="ellipsis-vertical"
      iconColor="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.mobileMoreTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.mobileMoreTooltip')"
      data-test-id="mobile-more"
      (click)="onMobileMore($event)"
    ></button>
  </div>
  } @else {
  <div class="shortcut-bar" [attr.aria-label]="t('humanDesign.chart.shortcutBar.ariaLabel')">
    <!-- Groep 1: info, edit, chart leegmaken -->
    <div class="shortcut-bar-group" role="group">
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="circle-info"
        [color]="primaryGateAction() === 'show-info' ? 'primary-75' : 'highlight'"
        [iconColor]="primaryGateAction() === 'show-info' ? undefined : 'primary-75'"
        [tooltip]="t('humanDesign.chart.shortcutBar.infoModeTooltip')"
        [attr.aria-pressed]="primaryGateAction() === 'show-info'"
        [disabled]="gameActive()"
        data-test-id="shortcut-info-mode"
        (click)="onPrimaryGateActionClick('show-info')"
      ></button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="pen"
        [color]="primaryGateAction() === 'configure' ? 'primary-75' : 'highlight'"
        [iconColor]="primaryGateAction() === 'configure' ? undefined : 'primary-75'"
        [tooltip]="t('humanDesign.chart.shortcutBar.editModeTooltip')"
        [attr.aria-pressed]="primaryGateAction() === 'configure'"
        [disabled]="gameActive()"
        data-test-id="shortcut-edit-mode"
        (click)="onPrimaryGateActionClick('configure')"
      ></button>
    </div>

    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" icon="eraser"
      iconColor="primary-75" [tooltip]="t('humanDesign.chart.shortcutBar.resetTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.resetTooltip')" data-test-id="shortcut-reset"
      (click)="resetRequested.emit()"></button>

    <!-- De herlaad-knop (ingebouwde preset opnieuw laden) is weg (2026-08-23):
         er zijn geen gebundelde presets meer; herberekenen van een library-
         chart gebeurt via het tab-contextmenu. -->

    <span class="shortcut-bar-divider"></span>

    <!-- Groep 2: zijde-modus (enkel design / volledig / enkel personality) — amber -->
    <div class="shortcut-bar-group" role="group">
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        [color]="sideMode() === 'design' ? 'elegant' : 'highlight'"
        [textColor]="sideMode() === 'design' ? undefined : 'primary-75'"
        [tooltip]="t(sideTooltipKey('design'))"
        [attr.aria-pressed]="sideMode() === 'design'"
        [disabled]="tripleViewActive()"
        data-test-id="shortcut-side-design"
        (click)="onSideModeClick('design')"
      >D</button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="circle-half-stroke"
        [color]="sideMode() === 'full' ? 'elegant' : 'highlight'"
        [iconColor]="sideMode() === 'full' ? undefined : 'primary-75'"
        [tooltip]="t(sideTooltipKey('full'))"
        [attr.aria-pressed]="sideMode() === 'full'"
        [disabled]="tripleViewActive()"
        data-test-id="shortcut-side-full"
        (click)="onSideModeClick('full')"
      ></button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        [color]="sideMode() === 'personality' ? 'elegant' : 'highlight'"
        [textColor]="sideMode() === 'personality' ? undefined : 'primary-75'"
        [tooltip]="t(sideTooltipKey('personality'))"
        [attr.aria-pressed]="sideMode() === 'personality'"
        [disabled]="tripleViewActive()"
        data-test-id="shortcut-side-personality"
        (click)="onSideModeClick('personality')"
      >P</button>
    </div>

    <!-- Drieluik: design | volledig | personality als drie gelijktijdige
         charts (spec 2026-07-31) — losse knop naast de zijde-groep. -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="triangle"
      [color]="tripleViewActive() ? 'elegant' : 'highlight'"
      [iconColor]="tripleViewActive() ? undefined : 'primary-75'"
      [tooltip]="t(tripleViewAvailable()
        ? 'humanDesign.chart.shortcutBar.tripleViewTooltip'
        : 'humanDesign.chart.shortcutBar.tripleViewUnavailableTooltip')"
      [attr.aria-pressed]="tripleViewActive()"
      [disabled]="!tripleViewAvailable()"
      data-test-id="shortcut-triple-view"
      (click)="tripleViewToggled.emit()"
    ></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Groep 3: weergave-modus (chart / mandala / beide) -->
    <div class="shortcut-bar-group" role="group">
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="sitemap"
        [color]="chartViewButtonActive() ? 'primary-75' : 'highlight'"
        [iconColor]="chartViewButtonActive() ? undefined : 'primary-75'"
        [tooltip]="t(chartViewTooltipKey())"
        [attr.aria-pressed]="chartViewButtonActive()"
        [disabled]="tripleViewActive()"
        data-test-id="shortcut-view-chart"
        (click)="onChartViewButtonClick()"
      ></button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="compass"
        [color]="viewMode() === 'mandala' ? 'primary-75' : 'highlight'"
        [iconColor]="viewMode() === 'mandala' ? undefined : 'primary-75'"
        [tooltip]="t(moonTransitActive() ? 'humanDesign.chart.shortcutBar.viewMandalaMoonTooltip' : 'humanDesign.chart.shortcutBar.viewMandalaTooltip')"
        [attr.aria-pressed]="viewMode() === 'mandala'"
        [disabled]="!mandalaOnlyAvailable()"
        data-test-id="shortcut-view-mandala"
        (click)="onViewModeClick('mandala')"
      ></button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="layer-group"
        [color]="viewMode() === 'both' ? 'primary-75' : 'highlight'"
        [iconColor]="viewMode() === 'both' ? undefined : 'primary-75'"
        [tooltip]="t(bothViewTooltipKey())"
        [attr.aria-pressed]="viewMode() === 'both'"
        [disabled]="tripleViewActive()"
        data-test-id="shortcut-view-both"
        (click)="onViewModeClick('both')"
      ></button>
    </div>

    <!-- Ring-toggles in wiel-volgorde van buiten naar binnen:
         kwartaal → I-Tjing → godhead → dierenriem (herschikking 2026-08-20). -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="chart-pie"
      [color]="showQuarterRing() ? 'primary-75' : 'highlight'"
      [iconColor]="showQuarterRing() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.quarterRingTooltip')"
      [attr.aria-pressed]="showQuarterRing()"
      [disabled]="!mandalaRingsAvailable()"
      data-test-id="shortcut-quarter-ring"
      (click)="quarterRingToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="yin-yang"
      [color]="showIchingRing() ? 'primary-75' : 'highlight'"
      [iconColor]="showIchingRing() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.ichingRingTooltip')"
      [attr.aria-pressed]="showIchingRing()"
      [disabled]="!mandalaRingsAvailable()"
      data-test-id="shortcut-iching-ring"
      (click)="ichingRingToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="masks-theater"
      [color]="showGodheadRing() ? 'primary-75' : 'highlight'"
      [iconColor]="showGodheadRing() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.godheadRingTooltip')"
      [attr.aria-pressed]="showGodheadRing()"
      [disabled]="!mandalaRingsAvailable()"
      data-test-id="shortcut-godhead-ring"
      (click)="godheadRingToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="bullseye"
      [color]="showZodiacRing() ? 'primary-75' : 'highlight'"
      [iconColor]="showZodiacRing() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.zodiacRingTooltip')"
      [attr.aria-pressed]="showZodiacRing()"
      [disabled]="!mandalaRingsAvailable()"
      data-test-id="shortcut-zodiac-ring"
      (click)="zodiacRingToggled.emit()"
    ></button>

    <div class="shortcut-bar-group" role="group">
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="moon"
        [color]="moonTransitActive() ? 'primary-75' : 'highlight'"
        [iconColor]="moonTransitActive() ? undefined : 'primary-75'"
        [tooltip]="t(moonTransitAvailable()
          ? 'humanDesign.chart.shortcutBar.moonTransitTooltip'
          : 'humanDesign.chart.shortcutBar.moonTransitUnavailableTooltip')"
        [disabled]="!moonTransitAvailable() || tripleViewActive()"
        [attr.aria-pressed]="moonTransitActive()"
        data-test-id="shortcut-moon-transit"
        (click)="moonTransitToggled.emit()"
      ></button>

      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="clock-rotate-left"
        [color]="justNowTransitActive() ? 'primary-75' : 'highlight'"
        [iconColor]="justNowTransitActive() ? undefined : 'primary-75'"
        [tooltip]="justNowTransitTooltip()"
        [disabled]="!justNowTransitAvailable() || justNowTransitLoading() || tripleViewActive()"
        [attr.aria-pressed]="justNowTransitActive()"
        [attr.aria-busy]="justNowTransitLoading()"
        data-test-id="shortcut-just-now-transit"
        (click)="justNowTransitToggled.emit()"
      ></button>


      <!-- Locks & Keys (spec 2026-08-27): precessie-sleutels op de mandala.
           De algemene weergave werkt ook zonder chart; enkel cycle-/composite-
           tabs vergrendelen de knop. -->
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="lock-keyhole"
        [color]="locksKeysActive() ? 'primary-75' : 'highlight'"
        [iconColor]="locksKeysActive() ? undefined : 'primary-75'"
        [tooltip]="t(locksKeysAvailable()
          ? 'humanDesign.chart.shortcutBar.locksKeysTooltip'
          : 'humanDesign.chart.shortcutBar.locksKeysUnavailableTooltip')"
        [disabled]="!locksKeysAvailable() || tripleViewActive()"
        [attr.aria-pressed]="locksKeysActive()"
        data-test-id="shortcut-locks-keys"
        (click)="locksKeysToggled.emit()"
      ></button>

      <!-- Transits-paneel (Nu & Straks + ephemeris-lanes): werkt ook zonder
           geladen chart (globale modus, besluit 14) → nooit unavailable. -->
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        icon="planet-ringed"
        [color]="transitsActive() ? 'primary-75' : 'highlight'"
        [iconColor]="transitsActive() ? undefined : 'primary-75'"
        [tooltip]="t('humanDesign.chart.transits.shortcutBar.transitsTooltip')"
        [attr.aria-pressed]="transitsActive()"
        data-test-id="shortcut-transits"
        (click)="transitsToggled.emit()"
      ></button>
    </div>

    <span class="shortcut-bar-divider"></span>

    <!-- Groep 5: annotatiemodus / annotaties wissen — coral red -->
    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="annotationActive() ? 'cta' : 'highlight'"
      icon="highlighter"
      [iconColor]="annotationActive() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.annotateTooltip')" data-test-id="shortcut-annotate"
      (click)="annotateToggled.emit()"></button>

    <button eBtn [size]="buttonSize()" squared type="button" color="highlight"
      icon="trash"
      iconColor="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.clearAnnotationsTooltip')" data-test-id="shortcut-clear-annotations"
      (click)="clearAnnotationsRequested.emit()"></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Groep 6: planeetpanelen / eenvoudige grid / weergave / GK / keynotes /
         statistieken / chart-blokjes / posities verslepen -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="showPlanetGrid() ? 'primary-75' : 'highlight'"
      icon="table-cells-large"
      [iconColor]="showPlanetGrid() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.planetGridTooltip')"
      [disabled]="!hasPlanetaryActivations()"
      data-test-id="shortcut-planet-grid"
      (click)="planetGridToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="simplePlanetGrid() ? 'primary-75' : 'highlight'"
      icon="list"
      [iconColor]="simplePlanetGrid() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.simpleGridTooltip')
        + (moonTransitActive() ? t('humanDesign.chart.shortcutBar.simpleGridLockedSuffix')
          : tripleViewActive() ? t('humanDesign.chart.shortcutBar.tripleViewLockedSuffix')
          : cycleCompositeLockedSuffix())"
      [disabled]="!simplePlanetGridAvailable()"
      data-test-id="shortcut-simple-planet-grid"
      (click)="simplePlanetGridToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="advancedLpsGrid() ? 'primary-75' : 'highlight'"
      icon="square-star"
      [iconColor]="advancedLpsGrid() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.advancedGridTooltip')
        + (moonTransitActive() ? t('humanDesign.chart.shortcutBar.advancedGridLockedSuffix')
          : tripleViewActive() ? t('humanDesign.chart.shortcutBar.tripleViewLockedSuffix')
          : cycleCompositeLockedSuffix())"
      [attr.aria-pressed]="advancedLpsGrid()"
      [disabled]="!advancedLpsGridAvailable()"
      data-test-id="shortcut-advanced-lps-grid"
      (click)="advancedLpsGridToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="planetGridVisualizationMode() !== 'classic' ? 'primary-75' : 'highlight'"
      icon="shapes"
      [iconColor]="planetGridVisualizationMode() !== 'classic' ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.visualizationModeTooltip', { mode: planetGridVisualizationMode() })
        + cycleCompositeLockedSuffix()"
      [disabled]="!extendedPlanetGridControlsAvailable()"
      data-test-id="shortcut-visualization-mode"
      (click)="visualizationModeToggled.emit()"
    ></button>

    @if (includeNonHdFeatures()) {
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        class="gene-keys-toggle"
        [color]="showGeneKeys() ? 'primary-75' : 'highlight'"
        [textColor]="showGeneKeys() ? undefined : 'primary-75'"
        [tooltip]="t('humanDesign.chart.shortcutBar.geneKeysTooltip') + cycleCompositeLockedSuffix()"
        [disabled]="!extendedPlanetGridControlsAvailable()"
        data-test-id="shortcut-gene-keys"
        (click)="geneKeysToggled.emit()"
      ><span class="gene-keys-label">GK</span></button>
    }

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="showHdKeynotes() ? 'primary-75' : 'highlight'"
      icon="message-lines"
      [iconColor]="showHdKeynotes() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.keynotesTooltip')"
      [disabled]="!hdKeynotesAvailable()"
      data-test-id="shortcut-keynotes"
      (click)="hdKeynotesToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="showCenterCheatSheet() ? 'primary-75' : 'highlight'"
      icon="memo-circle-info"
      [iconColor]="showCenterCheatSheet() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.centerCheatSheetTooltip')"
      [attr.aria-pressed]="showCenterCheatSheet()"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.centerCheatSheetAria')"
      [disabled]="!centerCheatSheetAvailable()"
      data-test-id="shortcut-center-cheat-sheet"
      (click)="centerCheatSheetToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="chart-bar"
      [color]="showSideStats() ? 'primary-75' : 'highlight'"
      [iconColor]="showSideStats() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.sideStatsTooltip') + cycleCompositeLockedSuffix()"
      [attr.aria-pressed]="showSideStats()"
      [disabled]="!sideStatsAvailable()"
      data-test-id="shortcut-side-stats"
      (click)="sideStatsToggled.emit()"
    ></button>

    <!-- Mini-planeetblokjes op de chart zelf (gate-block overlay) — los van
         de zijpanelen, dus buiten de showPlanetGrid-conditie. Bewust als
         voorlaatste, direct vóór het verplaats-gereedschap dat de blokjes
         (en cards) versleept. -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="showGateBlocks() ? 'primary-75' : 'highlight'"
      icon="cubes"
      [iconColor]="showGateBlocks() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.gateBlocksTooltip') + cycleCompositeLockedSuffix()"
      [attr.aria-pressed]="showGateBlocks()"
      [disabled]="!gateBlocksAvailable()"
      data-test-id="shortcut-gate-blocks"
      (click)="gateBlocksToggled.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      [color]="moveToolActive() ? 'cta' : 'highlight'"
      icon="up-down-left-right"
      [iconColor]="moveToolActive() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.moveToolTooltip')"
      [attr.aria-pressed]="moveToolActive()"
      [disabled]="!moveToolAvailable()"
      data-test-id="shortcut-move-tool"
      (click)="moveToolToggled.emit()"
      (contextmenu)="onMoveToolContextMenu($event)"
    ></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Sneeuwvlok ontdooien -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      icon="snowflake"
      color="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.unfreezeTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.unfreezeAria')"
      [disabled]="!isFrozen()"
      data-test-id="shortcut-unfreeze"
      (click)="unfreezeRequested.emit()"
    ></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Dock alle open / undock alle / sluit alle open info-panelen —
         verhuisd naar tussen bevriezen en de chart manager (2026-09-10). -->
    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      color="highlight"
      icon="thumbtack"
      iconColor="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.dockAllTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.dockAllTooltip')"
      [disabled]="!dockAllAvailable()"
      data-test-id="shortcut-dock-all"
      (click)="dockAllPanelsRequested.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      color="highlight"
      icon="arrow-up-right-from-square"
      iconColor="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.undockAllTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.undockAllTooltip')"
      [disabled]="!undockAllAvailable()"
      data-test-id="shortcut-undock-all"
      (click)="undockAllPanelsRequested.emit()"
    ></button>

    <button
      eBtn
      [size]="buttonSize()"
      squared
      type="button"
      color="highlight"
      icon="rectangle-xmark"
      iconColor="primary-75"
      [tooltip]="t('humanDesign.chart.shortcutBar.closeAllTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.closeAllTooltip')"
      [disabled]="!closeAllAvailable()"
      data-test-id="shortcut-close-all"
      (click)="closeAllPanelsRequested.emit()"
    ></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Chart manager — bewust de opvallende amber knop tussen de rest. -->
    <button eBtn [size]="buttonSize()" squared type="button" color="elegant" icon="table-list"
      [tooltip]="t('humanDesign.chart.shortcutBar.chartManagerTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.chartManagerAria')" data-test-id="shortcut-chart-manager"
      (click)="chartManagerRequested.emit()"></button>

    <!-- Nieuwe chart -->
    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" icon="user-plus"
      iconColor="primary-75" [tooltip]="t('humanDesign.chart.shortcutBar.newChartTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.newChartAria')" data-test-id="shortcut-new-chart"
      (click)="newChartRequested.emit()"></button>

    <!-- Chart opslaan (enkel zinvol bij een onopgeslagen chart) -->
    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" icon="floppy-disk"
      iconColor="primary-75" [tooltip]="t('humanDesign.chart.shortcutBar.saveChartTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.saveChartAria')" data-test-id="shortcut-save-chart"
      [disabled]="!canSaveChart()" (click)="saveChartRequested.emit()"></button>

    <!-- Chart delen via link (spec 2026-10-20): enkel op een opgeslagen eigen chart. -->
    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" icon="share-nodes"
      iconColor="primary-75" [tooltip]="t('humanDesign.chart.shortcutBar.shareChartTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.shareChartAria')" data-test-id="shortcut-share-chart"
      [disabled]="!canShareChart()" (click)="shareChartRequested.emit()"></button>

    <!-- Groep 7: Just Now Transit (het huidige moment, enkel personality, als eigen tab) -->
    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" [icon]="justNowTransitIcon"
      iconColor="primary-75" [tooltip]="t('humanDesign.chart.shortcutBar.justNowTooltip')"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.justNowTooltip')" data-test-id="shortcut-just-now"
      (click)="justNowRequested.emit()"></button>

    <span class="shortcut-bar-divider"></span>

    <!-- Groep 8: Spel (opent de spelkeuze-dialog) + lopend spel stoppen -->
    <button eBtn [size]="buttonSize()" squared type="button" icon="gamepad"
      [color]="gameMode() ? 'primary-75' : 'highlight'"
      [iconColor]="gameMode() ? undefined : 'primary-75'"
      [tooltip]="t('humanDesign.chart.shortcutBar.gameTooltip')"
      [attr.aria-pressed]="gameMode()"
      [attr.aria-label]="t('humanDesign.chart.shortcutBar.gameAria')" data-test-id="shortcut-game"
      (click)="gameRequested.emit()"></button>

    <button eBtn [size]="buttonSize()" squared type="button" color="highlight" icon="stop"
      iconColor="danger" [tooltip]="t('humanDesign.chart.shortcutBar.stopTooltip')" data-test-id="shortcut-stop"
      [disabled]="!gameActive()" (click)="stopRequested.emit()"></button>
  </div>
  }
</e-card2>
